import {useEffect} from 'react';
import {useMatch} from 'react-router';
import {useWhiteboardMetadata} from '../features/whiteboards/hooks/useWhiteboardMetadata';
import useAiWidgetStore from '../stores/useAiWidgetStore';

/**
 * On `/whiteboards/:whiteboardId`, pre-select that chart's Team group context.
 * Does not open CommunicationHub — user must expand the hub explicitly.
 */
export default function useChartTeamContext() {
    const match = useMatch('/charts/:whiteboardId');
    const whiteboardId = match?.params?.whiteboardId || null;
    const {whiteboard, metadataLoaded} = useWhiteboardMetadata(whiteboardId);
    const setActiveEntityGroup = useAiWidgetStore((s) => s.setActiveEntityGroup);
    const clearActiveEntityGroup = useAiWidgetStore((s) => s.clearActiveEntityGroup);

    useEffect(() => {
        if (!whiteboardId) {
            clearActiveEntityGroup();
            return;
        }

        const entityTitle = metadataLoaded
            ? (whiteboard?.title || 'Untitled')
            : (whiteboard?.title || 'Chart');

        setActiveEntityGroup({
            entityType: 'chart',
            entityId: whiteboardId,
            entityTitle,
        });
    }, [whiteboardId, whiteboard?.title, metadataLoaded, setActiveEntityGroup, clearActiveEntityGroup]);
}
